<template>
    <div class="mt-2" v-if="account">
        <v-btn
            v-if="!kollelForms.length || kollelForms.length == 1"
            color="success"
            class="mt-0"
            small
            @click="openKollelApplication"
            >Open Kollel Application</v-btn
        >
        <v-btn
            outline
            v-if="kollelForms.length > 1"
            v-for="form in kollelForms"
            color="success"
            class="mt-0"
            small
            @click="openKollelApplication({ id: form.id })"
            >Kollel Application {{ form.date | date }}</v-btn
        >
        <div
            class="headline text-success text-xs-center mb-3"
            v-if="account.isRegistered"
        >
            Registered
        </div>
        <div
            class="headline text-warning text-xs-center mb-3"
            v-if="!account.isRegistered"
        >
            Not Registered
        </div>

        <div v-if="registrationRequirments.length">
            <div
                v-for="(requirment, index) in registrationRequirments"
                class="mx-2"
            >
                <v-layout row class="pt-2">
                    <v-icon
                        class="mr-3 ml-1"
                        dark
                        :color="requirment.isCompleted ? 'success' : 'red'"
                        >{{
                            requirment.isCompleted
                                ? "mdi-check-circle"
                                : "mdi-alert-circle"
                        }}</v-icon
                    >
                    <div class="title">{{ requirment.reqType }}</div>
                </v-layout>
                <div
                    class="ml-4 pl-2"
                    v-html="getRequirmentDescription(requirment)"
                ></div>
                <v-divider
                    class="pb-2 mt-2"
                    v-if="index + 1 < registrationRequirments.length"
                    :key="index"
                >
                </v-divider>
            </div>
        </div>

        <v-dialog
            persistent
            v-model="kollelApplicationDialog"
            :max-width="kollelApplicationDialogWidth"
        >
            <v-card class="pa-4">
                <v-card-title class="headline px-0 mb-2 pt-0"
                    >Kollel Application</v-card-title
                >
                <v-form ref="form">
                    <v-layout row>
                        <v-btn
                            small
                            class="mb-3 mt-0"
                            color="success"
                            :loading="uploading"
                            style="height: 35px;"
                            @click="pickFile()"
                            ><v-icon dark left>mdi-cloud-upload</v-icon
                            >Upload</v-btn
                        >
                        <!-- <div class="mt-2 ml-2">
                            Application Status:
                            {{
                                kollelApplicationDocuments.length
                                    ? "Uploaded"
                                    : "Not Uploaded"
                            }}
                        </div> -->
                        <input
                            type="file"
                            style="display: none"
                            ref="files"
                            accept="image/*,.pdf"
                            @change="onFilePicked($event)"
                        />
                        <v-btn
                            v-if="kollelApplication.documentURL"
                            small
                            class="mt-0 ml-3"
                            @click="openDocument()"
                            style="height: 35px;"
                        >
                            <v-icon color="red" left dark>mdi-file-pdf</v-icon>
                            <span class="mr-2">Kollel Application</span>
                            <v-icon right>mdi-download</v-icon>
                        </v-btn>
                        <v-btn
                            class="mt-0"
                            v-if="kollelApplication.documentURL"
                            small
                            icon
                            @click.stop="deleteDocument()"
                            ><v-icon color="red"
                                >mdi-delete-forever</v-icon
                            ></v-btn
                        >
                    </v-layout>
                    <div style="overflow-y: auto; height: 500px">
                        <v-layout row>
                            <div class="font-weight-medium mr-2">
                                Name:
                            </div>
                            <div>{{ kollelApplication.name }}</div>
                            <v-spacer></v-spacer>
                            <div class="font-weight-medium mr-2">
                                Address:
                            </div>
                            <div>{{ kollelApplication.address }}</div>
                            <v-spacer></v-spacer>
                            <div class="font-weight-medium mr-2">
                                Phone:
                            </div>
                            <div>{{ kollelApplication.homePhone }}</div>
                        </v-layout>
                        <v-divider
                            style="border-color: #4caf50; margin-top: 13px;"
                            class="mt-2 pt-2"
                        ></v-divider>
                        <v-layout row>
                            <v-select
                                color="success"
                                :items="['ניין', 'יא']"
                                v-model="kollelApplication.onKollelPayroll"
                                class="mb-0 mt-2"
                                :rules="required"
                                reverse
                                label="באקומט כולל געלט
"
                            ></v-select>
                            <v-select
                                color="success"
                                :items="['ניין', 'יא']"
                                v-model="kollelApplication.kollelTimeAllDay"
                                class="mb-0 mt-2 ml-3"
                                :rules="required"
                                reverse
                                label="לערנט איר אין כולל א גאנצן טאג"
                            ></v-select>
                        </v-layout>
                        <v-layout row class="pa-0 ma-0">
                            <v-divider
                                style="border-color: #4caf50; margin-top: 13px;"
                                class="mt-2 pt-2"
                            ></v-divider>
                            <div class="font-weight-medium ml-2">
                                כולל לשנת תשפ"ג
                            </div>
                        </v-layout>
                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <v-radio-group
                                v-model="kollelApplication.kollelType"
                                row
                                style="max-width: 326px;"
                            >
                                <v-radio
                                    label="כולל אברכים תורה ויראה"
                                    value="satmar"
                                    color="success"
                                ></v-radio>
                                <v-radio
                                    label="אנדערע כולל"
                                    value="other"
                                    color="success"
                                ></v-radio>
                            </v-radio-group>
                        </v-layout>
                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <v-select
                                v-if="kollelApplication.kollelType == 'satmar'"
                                color="success"
                                style="max-width: 300px;"
                                :items="satmarKollelNames"
                                v-model="kollelApplication.kollelName"
                                class="my-0 pt-0"
                                reverse
                                :rules="required"
                                label="כולל אברכים תורה ויראה"
                            ></v-select>
                        </v-layout>

                        <div v-if="kollelApplication.kollelType == 'other'">
                            <v-layout row>
                                <v-text-field
                                    autocomplete="new-password"
                                    label="כולל אדרעס"
                                    v-model="kollelApplication.kollelAddress"
                                    ref="kollelAddress"
                                    :rules="required"
                                    reverse
                                ></v-text-field>
                                <v-text-field
                                    autocomplete="new-password"
                                    label="נאמען פון כולל"
                                    v-model="kollelApplication.kollelName"
                                    ref="kollelName"
                                    :rules="required"
                                    class="ml-3"
                                    reverse
                                ></v-text-field>
                            </v-layout>
                            <v-layout row>
                                <v-text-field
                                    autocomplete="new-password"
                                    label="ראש הכולל סעלפאן"
                                    v-model="
                                        kollelApplication.roshHakollelPhone
                                    "
                                    ref="roshHakollelPhone"
                                    :rules="required"
                                    reverse
                                ></v-text-field>
                                <v-text-field
                                    autocomplete="new-password"
                                    class="ml-3"
                                    label="ראש הכולל"
                                    v-model="kollelApplication.roshHakollel"
                                    ref="roshHakollel"
                                    :rules="required"
                                    reverse
                                ></v-text-field>
                            </v-layout>
                        </div>
                        <v-layout row class="pa-0 ma-0">
                            <v-divider
                                style="border-color: #4caf50; margin-top: 13px;"
                                class="mt-2 pt-2"
                            ></v-divider>
                            <div class="font-weight-medium ml-2">
                                נאכמיטאג כולל
                            </div>
                        </v-layout>
                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <v-radio-group
                                v-model="kollelApplication.kollelType2"
                                row
                                style="max-width: 326px"
                            >
                                <v-radio
                                    label="כולל אברכים תורה ויראה"
                                    value="satmar"
                                    color="success"
                                ></v-radio>
                                <v-radio
                                    label="אנדערע כולל"
                                    value="other"
                                    color="success"
                                ></v-radio>
                            </v-radio-group>
                        </v-layout>
                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <v-select
                                v-if="kollelApplication.kollelType2 == 'satmar'"
                                color="success"
                                style="max-width: 300px;"
                                :items="satmarKollelNames"
                                v-model="kollelApplication.kollelName2"
                                class="my-0 pt-0"
                                reverse
                                label="כולל אברכים תורה ויראה"
                            ></v-select>
                        </v-layout>

                        <div v-if="kollelApplication.kollelType2 == 'other'">
                            <v-layout row>
                                <v-text-field
                                    autocomplete="new-password"
                                    label="כולל אדרעס"
                                    v-model="kollelApplication.kollelAddress2"
                                    ref="kollelAddress2"
                                    reverse
                                ></v-text-field>
                                <v-text-field
                                    autocomplete="new-password"
                                    label="נאמען פון כולל"
                                    v-model="kollelApplication.kollelName2"
                                    ref="kollelName2"
                                    reverse
                                    class="ml-3"
                                ></v-text-field>
                            </v-layout>
                            <v-layout row>
                                <v-text-field
                                    autocomplete="new-password"
                                    label="ראש הכולל סעלפאן"
                                    v-model="
                                        kollelApplication.roshHakollelPhone2
                                    "
                                    ref="roshHakollelPhone2"
                                    reverse
                                    :rules="required"
                                ></v-text-field>
                                <v-text-field
                                    autocomplete="new-password"
                                    label="ראש הכולל"
                                    v-model="kollelApplication.roshHakollel2"
                                    ref="roshHakollel2"
                                    reverse
                                    class="ml-3"
                                ></v-text-field>
                            </v-layout>
                        </div>

                        <v-layout row class="pa-0 ma-0">
                            <v-divider
                                style="border-color: #4caf50; margin-top: 13px;"
                                class="mt-2 pt-2"
                            ></v-divider>
                            <div class="font-weight-medium ml-2">
                                פרנסה
                            </div>
                        </v-layout>
                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <v-select
                                color="success"
                                reverse
                                :items="['ניין', 'יא']"
                                v-model="kollelApplication.wifeHasJob"
                                class="my-0"
                                style="max-width: 300px;"
                                :rules="required"
                                label="האט די בעה'ב'סטע א דזשאב/פרנסה"
                            ></v-select>
                        </v-layout>
                        <v-layout
                            row
                            v-if="kollelApplication.wifeHasJob == 'יא'"
                        >
                            <v-text-field
                                autocomplete="new-password"
                                label="וויפיל יאר ארבעט מען דארט"
                                type="number"
                                v-model="kollelApplication.wivesJobYears"
                                ref="wivesJobYears"
                                reverse
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                label="פאזיצע"
                                v-model="kollelApplication.wivesPosition"
                                ref="wivesPosition"
                                class="ml-3"
                                reverse
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                label="נאמען פון ביזנעס/בעה''ב"
                                v-model="kollelApplication.wivesJob"
                                ref="wivesJob"
                                class="ml-3"
                                reverse
                            ></v-text-field>
                        </v-layout>
                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <v-select
                                color="success"
                                :items="['ניין', 'יא']"
                                v-model="kollelApplication.hasJob"
                                class="my-0"
                                :rules="required"
                                reverse
                                style="max-width: 300px"
                                label="זענט איר עוסק אין סיי וועלכע פרנסה"
                            ></v-select
                        ></v-layout>
                        <v-layout row v-if="kollelApplication.hasJob == 'יא'">
                            <v-text-field
                                autocomplete="new-password"
                                label="וועלכע פרנסה זענט איר עוסק"
                                v-model="kollelApplication.sideJob"
                                ref="sideJob"
                                reverse
                            ></v-text-field>
                        </v-layout>

                        <v-text-field
                            autocomplete="new-password"
                            label="Note"
                            v-model="kollelApplication.note"
                            ref="note"
                        ></v-text-field>
                        <!-- <v-select
                                label="Status"
                                :items="[
                                    'SUBMITTED',
                                    'APPROVED FULL KOLLEL',
                                    'APPROVED KOLLEL WITH SIDE INCOME',
                                ]"
                                v-model="kollelApplication.status"
                                ref="status"
                            ></v-select> -->
                    </div>
                </v-form>
                <v-card-actions class="mr-0 mt-2 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="kollelApplicationDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="saveKollelApllication"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { formatPhoneNumber, except, toTitleCase } from "../../utils/helpers.js";
import moment from "moment";

export default {
    props: {
        account: Object,
        registrationRequirments: Array,
        students: Array,
    },
    data() {
        return {
            kollelApplicationDialog: false,
            kollelApplicationDialogWidth: "800",
            processing: false,
            uploading: false,
            files: [],
            kollelForms: [],
            kollelApplicationDocuments: [],

            required: [(value) => !!value || "Required."],

            pdfDucmentNumberOfPages: "",

            pageCount: 0,
            currentPage: 0,

            satmarKollelNames: [
                "סניף תהלות יואל",
                "סניף קליימער",
                "סניף קיעפ קומה א׳",
                "סניף קיעפ קומה ב׳",
                "כולל גפ״ת",
            ],

            kollelApplication: {
                id: "",
                onKollelPayroll: "",
                kollelTimeAllDay: "",
                kollelName: "",
                kollelAddress: "",
                kollelTime: "",
                roshHakollel: "",
                kollelName2: "",
                kollelAddress2: "",
                kollelTime2: "",
                roshHakollel2: "",
                hasJob: false,
                sideJob: "",
                wifeHasJob: false,
                wivesJob: "",
                wivesPosition: "",
                wivesJobYears: "",
                note: "",
                status: "SUBMITTED",
                documentURL: "",
                source: "",
                kollelType: "",
                kollelType2: "",
                name: "",
                homePhone: "",
                address: "",
            },
        };
    },
    async created() {
        const response = await this.$http.get(
            "api/kollelForms/getApplication?accountID=" + this.account.accountID
        );

        this.kollelForms = response.kollelForms;

        if (this.$route.query.goToRegistrationKollel) {
            this.openKollelApplication({ id: this.$route.query.kollelFormID });
        }
    },
    computed: {},
    methods: {
        formatPhoneNumber(phone) {
            return formatPhoneNumber(phone);
        },
        getRequirmentDescription(requirment) {
            return this.getStudentName(requirment) + requirment.description;
        },
        getStudentName(requirment) {
            if (!this.students.length || !requirment.studentID) return "";

            const student = this.students.find(
                (s) => s.studentID.trim() == requirment.studentID.trim()
            );

            return student
                ? `<span class="font-weight-medium">${student.engName}: </span>`
                : "";
        },
        getStudentProperties(student) {
            return Object.keys(
                except(student, "did", "pin", "hebName", "engName")
            ).map((key) => {
                const value =
                    key == "dob"
                        ? moment(student[key]).format("MM/DD/YYYY h:mm:ss A")
                        : student[key];
                return {
                    name: toTitleCase(key),
                    value: value,
                };
            });
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();

                this.files = files;

                formData.append("upload_file", this.files[0]);

                const response = await this.$http.post(
                    "api/kollelForms/uploadKollelApplication?accountID=" +
                        this.account.accountID,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                this.kollelApplication.documentURL = response;
                //this.kollelApplicationDialogWidth = 1200;

                //this.updatePdfPages();

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        updatePdfPages() {
            pdfjsLib
                .getDocument(this.kollelApplication.documentURL)
                .then((doc) => {
                    this.pdfDucmentNumberOfPages = doc.numPages;
                    console.log(doc.numPages);
                });
        },
        openDocument() {
            window.open(this.kollelApplication.documentURL);
        },
        deleteDocument() {
            this.kollelApplication.documentURL = "";
        },
        async openKollelApplication({ id = null }) {
            //this.kollelApplicationDocuments = response.kollelDocuments || [];

            // this.kollelApplication.name = this.account.hname;
            // this.kollelApplication.homePhone = this.account.homePhone;
            // this.kollelApplication.address = this.account.address1;

            const form = id
                ? this.kollelForms.find((f) => f.id == id)
                : this.kollelForms.length
                ? this.kollelForms[0]
                : undefined;

            if (!id && this.kollelForms.length == 1) {
                id = this.kollelForms[0].id;
            }

            // if (form) {
            //     this.kollelApplication.id = form.id;
            //     this.kollelApplication.onKollelPayroll = form.onKollelPayroll;
            //     this.kollelApplication.kollelTimeAllDay =
            //         form.kollelTime == "allday"
            //             ? "יא"
            //             : form.kollelTime == "morning"
            //             ? "ניין"
            //             : "";
            //     this.kollelApplication.kollelName = form.kollelName;
            //     this.kollelApplication.kollelType = form.kollelType;
            //     this.kollelApplication.kollelType2 = form.kollelType2;
            //     this.kollelApplication.kollelAddress = form.kollelAddress;
            //     this.kollelApplication.kollelTime = form.kollelTime;
            //     this.kollelApplication.roshHakollel = form.roshHakollel;
            //     this.kollelApplication.kollelName2 = form.kollelName2;
            //     this.kollelApplication.kollelAddress2 = form.kollelAddress2;
            //     this.kollelApplication.kollelTime2 = form.kollelTime2;
            //     this.kollelApplication.roshHakollel2 = form.roshHakollel2;
            //     this.kollelApplication.hasJob = form.hasJob;
            //     this.kollelApplication.sideJob = form.sideJob;
            //     this.kollelApplication.wifeHasJob = form.wifeHasJob;
            //     this.kollelApplication.wivesJob = form.wivesJob;
            //     this.kollelApplication.wivesPosition = form.wivesPosition;
            //     this.kollelApplication.wivesJobYears = form.wivesJobYears;
            //     this.kollelApplication.note = form.note;
            //     this.kollelApplication.status = form.status;
            //     this.kollelApplication.documentURL = form.documentURL;
            //     this.kollelApplication.source = form.source;
            // }

            this.$router.push(
                "/kollel-application/" +
                    this.account.accountID +
                    (id ? "/" + id.toString() : "")
            );
        },
        collectFormData() {
            return {
                id: this.kollelApplication.id || 0,
                date: moment().format("YYYY-MM-DD HH:mm:ss"),
                accountID: this.account.accountID,
                name: this.account.hname,
                homePhone: this.account.homePhone.replace(/\D/g, ""),
                address: this.account.address1,
                cellphone: this.account.cellPhone.replace(/\D/g, ""),
                father: this.account.father,
                fatherInLaw: this.account.shver,
                kollelName: this.kollelApplication.kollelName,
                kollelAddress: this.kollelApplication.kollelAddress,
                kollelTime:
                    this.kollelApplication.kollelTimeAllDay == "יא"
                        ? "allday"
                        : "morning",
                roshHakollel: this.kollelApplication.roshHakollel,
                kollelName2: this.kollelApplication.kollelName2,
                kollelAddress2: this.kollelApplication.kollelAddress2,
                kollelTime2: this.kollelApplication.kollelTime2,
                kollelType: this.kollelApplication.kollelType,
                kollelType2: this.kollelApplication.kollelType2,
                roshHakollel2: this.kollelApplication.roshHakollel2,
                onKollelPayroll: this.kollelApplication.onKollelPayroll,
                documentURL: this.kollelApplication.documentURL,
                sideJob: this.kollelApplication.hasJob
                    ? this.kollelApplication.sideJob
                    : null,
                wifeHasJob: this.kollelApplication.wifeHasJob,
                hasJob: this.kollelApplication.hasJob,
                wivesJob: this.kollelApplication.wifeHasJob
                    ? this.kollelApplication.wivesJob
                    : null,
                wivesPosition: this.kollelApplication.wifeHasJob
                    ? this.kollelApplication.wivesPosition
                    : null,
                wivesJobYears: this.kollelApplication.wifeHasJob
                    ? this.kollelApplication.wivesJobYears
                    : null,
                source: this.kollelApplication.source
                    ? this.kollelApplication.source
                    : "ADMIN PORTAL",
                status: this.kollelApplication.status,
                note: this.kollelApplication.note,
                updatedBy: this.$store.state.authentication.user,
            };
        },
        async saveKollelApllication() {
            if (!this.$refs.form.validate(true)) return;

            if (
                !this.kollelApplication.documentURL &&
                this.kollelApplication.source != "DDC"
            ) {
                return this.$notify({
                    text: "Please Upload Application",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/kollelForms/fillKollelForm",
                    this.collectFormData()
                );

                this.processing = false;
                this.kollelApplicationDialog = false;
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.card-width {
    max-width: 65%;
}
</style>
